module.exports = __webpack_public_path__ + "img/1537715382.7c029818.jpg";